export default __webpack_public_path__ + "static/web-layout-advance-matrix-iamge-9a56af991e8a877cfa04e4cd518c86ee.png";